import React, { Component } from 'react';
import { connect } from 'react-redux';
import { object } from 'prop-types';

import ReportLibraryModule from 'ps-components/Modules/ReportLibrary/ReportLibraryContainer';

class ReportLibrary extends Component {
  static propTypes = {
    session: object,
    group: object,
    launchDarklyFeatureFlags: object
  };

  render() {
    return (
      <ReportLibraryModule
        userId={this.props.session.user.id}
        groupId={this.props.group.groupId}
        userEmail={this.props.session.user.email}
        defaultGroupId={this.props.session.organization.defaultGroup.id}
        userSuperAdmin={this.props.session.user.rights.superAdmin}
        userSiteAdmin={this.props.session.user.rights.siteAdmin}
        userGroupAdmin={this.props.session.user.rights.groupAdmin}
        userReportViewer={this.props.session.user.rights.reportViewUser}
        readOnlyUser = {this.props?.session?.user?.rights?.readOnlyUser}
        primaryRole = {this.props?.session?.user?.rights?.primaryRole}
        userRights={this.props?.session?.userRights}
        reportViewerRights={this.props.session.reportViewerRights}
        noReportsStatusImage={'/view/static/mp/images/empty_models.svg'}
        groupFunctionality={true}
        visualizationFunctionality={true}
        userGroupCount={this.props?.session?.userGroupCount}
        launchDarklyFeatureFlags={this.props.launchDarklyFeatureFlags}
      />
    );
  }
}

const mapStateToProps = ({ session, group }) => ({ session, group });

export default connect(mapStateToProps, null)(ReportLibrary);
